exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedor-grid{\r\n    margin-top: 1rem;\r\n    margin-left: 1rem;\r\n    margin-right:1rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-salida-list/documento-salida-list.component.css
// module id = ../../../../../src/app/components/documento-salida-list/documento-salida-list.component.css
// module chunks = main